import {
  PaymentMethodIntent,
  PaymentMethodPaymentType,
  PaymentMethodStatus,
  PaymentMethodType,
} from '@Common/types/bo/b2b/companies';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const paymentMethodPaymentTypeChoices = makeChoicesCommon<PaymentMethodPaymentType>()({
  recurring: 'resources.bo_common.b2b.companies.payment_methods.choices.payment_types.recurring',
  one_off: 'resources.bo_common.b2b.companies.payment_methods.choices.payment_types.one_off',
});

export const paymentMethodStatusChoices = makeChoicesCommon<PaymentMethodStatus>()({
  active: 'resources.bo_common.b2b.companies.payment_methods.choices.statuses.active',
  deleted: 'resources.bo_common.b2b.companies.payment_methods.choices.statuses.deleted',
  pending: 'resources.bo_common.b2b.companies.payment_methods.choices.statuses.pending',
  rejected: 'resources.bo_common.b2b.companies.payment_methods.choices.statuses.rejected',
  awaiting_customer:
    'resources.bo_common.b2b.companies.payment_methods.choices.statuses.awaiting_customer',
  awaiting_signature:
    'resources.bo_common.b2b.companies.payment_methods.choices.statuses.awaiting_signature',
});

export const paymentMethodTypeChoices = makeChoicesCommon<PaymentMethodType>()({
  sepa_direct_debit:
    'resources.bo_common.b2b.companies.payment_methods.choices.payment_method_type.sepa_direct_debit',
  external_bank:
    'resources.bo_common.b2b.companies.payment_methods.choices.payment_method_type.external_bank',
});

export const paymentMethodIntentChoices = makeChoicesCommon<PaymentMethodIntent>()({
  principal: 'resources.bo_common.b2b.companies.payment_methods.choices.intents.principal',
  invoicing: 'resources.bo_common.b2b.companies.payment_methods.choices.intents.invoicing',
  ccb_withdrawal:
    'resources.bo_common.b2b.companies.payment_methods.choices.intents.ccb_withdrawal',
});
